import { render, staticRenderFns } from "./AVODHeroSection.vue?vue&type=template&id=2e51f6e6&scoped=true"
import script from "./AVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AVODHeroSection.vue?vue&type=style&index=0&id=2e51f6e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51f6e6",
  null
  
)

export default component.exports